import { format } from 'date-fns';
import { resolveTeamCDNDir } from '@gjensidige/se-content-helpers';

import { DocumentLinksProps, LinkDetails } from './types';

export const mapAPIToLegalLinks = (
  props: DocumentLinksProps
): LinkDetails[] => {
  const linkDetailsArray: LinkDetails[] = [];
  const productDocumentsAPI = props.productDocuments;
  if (productDocumentsAPI) {
    const cdnDocumentsURL =
      resolveTeamCDNDir('service-sweden') + 'product-documents-se';
    if (
      productDocumentsAPI.prePurchaseInfos &&
      productDocumentsAPI.prePurchaseInfos.length > 0
    ) {
      const prePurchaseDocLink = filterActiveDocument(
        productDocumentsAPI.prePurchaseInfos
      );
      prePurchaseDocLink &&
        linkDetailsArray.push({
          isIPID: false,
          docId: prePurchaseDocLink.docId,
          linkText: props.prepurchaseInfoTitle,
          linkAddress: cdnDocumentsURL + prePurchaseDocLink.documentPath
        });
    }

    if (
      productDocumentsAPI.ipidDocumentPath &&
      productDocumentsAPI.ipidDocumentPath.length > 0
    )
      linkDetailsArray.push({
        isIPID: true,
        linkText: props.ipidTitle,
        linkAddress: productDocumentsAPI.ipidDocumentPath[0]
      });

    if (
      productDocumentsAPI.termsAndConditions &&
      productDocumentsAPI.termsAndConditions.length > 0
    ) {
      const termsAndConditionLInk = filterActiveDocument(
        productDocumentsAPI.termsAndConditions
      );
      termsAndConditionLInk &&
        linkDetailsArray.push({
          isIPID: false,
          docId: termsAndConditionLInk.docId,
          linkText: props.termsAndConditionsTitle,
          linkAddress: cdnDocumentsURL + termsAndConditionLInk.documentPath
        });
    }
  }
  return linkDetailsArray;
};

export const filterActiveDocument = (documentList: any) => {
  const currentDate = new Date().valueOf();
  const activeDocument = documentList.find(
    (terms: any) =>
      new Date(currentDate) >= new Date(terms.startDate) &&
      new Date(currentDate) <= new Date(terms.endDate)
  );
  return activeDocument || '';
};
